<div class="container" *ngIf="modalData.name === 'create'">
  <div class="row">
    <div class="col-md-10"></div>

    <div class="col-md-2">
      <span
        id="modal-cancel-button"
        (click)="closeModal()"
        style="cursor: pointer;"
      >
        <mat-icon
          class="example-tab-icon close"
          style="font-size: 28px !important;"
          >close</mat-icon
        >
      </span>
    </div>
  </div>
  <form [formGroup]="scholarshipPaymentForm">
    <div class="row">
      <div class="col-md-6">
        <mat-form-field class="full-width-field" id="id_number">
          <input matInput placeholder="Name" formControlName="StudentName" />
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <mat-form-field class="full-width-field" id="id_number">
          <input
            matInput
            placeholder="Scholarship Award No"
            formControlName="ScholarshipAwardNo"
          />
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <mat-form-field class="full-width-field" id="id_number">
          <mat-label>Enter Amount Paid</mat-label>
          <input matInput type="number" formControlName="AmountPaid" />

          <mat-error *ngIf="errorHandling('AmountPaid', 'required')">
            You must provide <strong>amount paid</strong>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <mat-form-field class="full-width-field" id="id_number">
          <mat-select placeholder="Select Bank" formControlName="BankName">
            <mat-option *ngFor="let bank of bankDetails" [value]="bank.id">{{
              bank.BeneficiaryAccountName
            }}</mat-option>
          </mat-select>
          <mat-error *ngIf="errorHandling('BankId', 'required')">
            You must provide <strong>bank</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <mat-form-field class="full-width-field" id="id_number">
          <input
            matInput
            [matDatepicker]="picker"
            formControlName="DatePaid"
            placeholder="Select Date Paid"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-hint></mat-hint>

          <mat-error *ngIf="errorHandling('DatePaid', 'required')">
            You must provide <strong>date paid</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="full-width-field" id="id_number">
          <mat-select
            placeholder="Select Payment Mode"
            formControlName="PaymentMode"
          >
            <mat-option value="Bank">Bank</mat-option>
            <mat-option value="Cheque">Cheque</mat-option>
            <mat-option value="Transfer">Transfer</mat-option>
            <mat-option value="Cash">Cash</mat-option>
          </mat-select>
          <mat-error *ngIf="errorHandling('BankId', 'required')">
            You must provide <strong>payment mode</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <mat-form-field class="full-width-field" id="id_number">
          <mat-label>Enter Payment Description</mat-label>
          <textarea matInput formControlName="PaymentDescription"></textarea>

          <mat-error *ngIf="errorHandling('PaymentDescription', 'required')">
            You must provide <strong>payment description</strong>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <mat-form-field class="full-width-field" id="id_number">
          <mat-select
            placeholder="Select Currency"
            formControlName="CurrencyId"
          >
            <mat-option
              *ngFor="let currency of currencies"
              [value]="currency.id"
              >{{ currency.CurrencyName }}</mat-option
            >
          </mat-select>
          <mat-error *ngIf="errorHandling('CurrencyId', 'required')">
            You must provide <strong>bank</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <!-- <pre>{{scholarshipPaymentForm.value | json}}</pre> -->

    <div class="row justify-content-center mt-5">
      <div class="col-md-12">
        <mat-dialog-actions align="center">
          <button
            mat-raised-button
            id="modal-action-button"
            (click)="onSubmit(scholarshipPaymentForm.value)"
          >
            Save
          </button>
          <button
            mat-raised-button
            id="modal-cancel-button"
            (click)="openBankDetail()"
          >
            Add Beneficiary Bank Account
          </button>
          <!-- <button mat-raised-button  id="modal-cancel-button" (click)="closeModal()">
                  Go back
              </button> -->
        </mat-dialog-actions>
      </div>
    </div>
  </form>
</div>

<div class="container" *ngIf="modalData.name === 'view'">
  <div class="row">
    <div class="col-md-10"></div>

    <div class="col-md-2">
      <span
        id="modal-cancel-button"
        (click)="closeModal()"
        style="cursor: pointer;"
      >
        <mat-icon
          class="example-tab-icon close"
          style="font-size: 28px !important;"
          >close</mat-icon
        >
      </span>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <h3 class="heading">Payment Information</h3>
      <div class="the_info row">
        <h5 class="main__info col-md-4 mb-4">
          <span class="label d-block">Student Name</span>
          <span class="info d-block">{{
            paymentInfo.studentInfo.StudentName
          }}</span>
        </h5>
        <h5 class="main__info col-md-4 mb-4">
          <span class="label d-block">Scholarship Award No.</span>
          <span class="info d-block">{{
            paymentInfo?.studentInfo.ScholarshipAwardNo
          }}</span>
        </h5>
        <h5 class="main__info col-md-4 mb-4">
          <span class="label d-block">Account No</span>
          <span class="info d-block">{{
            paymentInfo?.studentBankDetail.BeneficiaryAccountNumber
          }}</span>
        </h5>
        <h5 class="main__info col-md-4 mb-4">
          <span class="label d-block">Account Name</span>
          <span class="info d-block">{{
            paymentInfo?.studentBankDetail.BeneficiaryAccountName
          }}</span>
        </h5>
        <h5 class="main__info col-md-4 mb-4">
          <span class="label d-block">Bank Name</span>
          <span class="info d-block">{{
            paymentInfo?.studentBankDetail.BeneficiaryAccountName
          }}</span>
        </h5>
        <h5 class="main__info col-md-4 mb-4">
          <span class="label d-block">Branch</span>
          <span class="info d-block">{{
            paymentInfo?.studentBankDetail.Branch
          }}</span>
        </h5>
        <h5 class="main__info col-md-4 mb-4">
          <span class="label d-block">Amount Paid</span>
          <span class="info d-block">{{
            paymentInfo?.studentInfo.AmountPaid
              | currency: paymentInfo?.CurrencyId:'symbol-narrow'
          }}</span>
        </h5>

        <h5 class="main__info col-md-4 mb-4">
          <span class="label d-block">payment Description</span>
          <span class="info d-block">{{
            paymentInfo?.studentInfo.PaymentDescription
          }}</span>
        </h5>

        <h5 class="main__info col-md-4 mb-4">
          <span class="label d-block">Date Paid</span>
          <span class="info d-block">{{
            paymentInfo?.studentInfo.DatePaid | date
          }}</span>
        </h5>
        <h5 class="main__info col-md-4 mb-4">
          <span class="label d-block">Posted By</span>
          <span class="info d-block">{{
            paymentInfo?.studentInfo.PostedBy
          }}</span>
        </h5>
        <h5 class="main__info col-md-4 mb-4">
          <span class="label d-block">Payment Mode</span>
          <span class="info d-block">{{
            paymentInfo?.studentInfo.PaymentMode
          }}</span>
        </h5>
      </div>
    </div>
  </div>

  <!-- <div class="row mt-4">
            <div class="col-md-12">
              <mat-dialog-actions align="center">

              <button mat-raised-button  id="modal-cancel-button" (click)="closeModal()">
                  Go back
              </button>
              </mat-dialog-actions>


            </div>
          </div> -->
</div>

<div class="container" *ngIf="modalData.name === 'report'">
  <div class="row">
    <div class="col-md-12" id="print-section">
      <h3 class="heading">Beneficiary Payment Report</h3>

      <div class="top_segment">
        <div class="actual_top row">
          <div
            class="logo col-md-7"
            style="text-align: right; font-size: 1.8rem;"
          >
            UDSP-Social Investment Management System
          </div>
          <p
            class="col-md-5"
            style="
              color: black;
              font-weight: bold;
              font-size: 1.4rem;
              text-align: right;
            "
          >
            <span> {{ date | date: 'fullDate' }}</span>
            <span class="ml-5">{{ date | date: 'h:mm:ss a' }}</span>
          </p>
        </div>
        <h3 class="heading">Beneficiary Payment Report History</h3>
      </div>
      <h4 class="heading">Beneficiary Details</h4>
      <section class="beneficiary__detail row">
        <div class="col-md-3">
          <img
            src="{{ studentInfo.StudentPassport }}"
            alt=""
            srcset=""
            style="width: 100%; height: 250px;"
          />
        </div>
        <div class="col-md-9">
          <div class="main__detail row">
            <h5 class="main_info col-md-4 mb-5">
              <span class="label d-block">Student Name</span>
              <span class="info"
                >{{ studentInfo?.BeneficarySurname }}
                {{ studentInfo?.BeneficaryFirstname }}
                {{ studentInfo?.BeneficaryOthername }}</span
              >
            </h5>
            <h5 class="main_info col-md-4 mb-5">
              <span class="label d-block">Date Of Birth</span>
              <span class="info">{{ studentInfo?.DateOfBirth | date }}</span>
            </h5>
            <h5 class="main_info col-md-4 mb-5">
              <span class="label d-block">State</span>
              <span class="info">{{ getStateName(studentInfo?.State) }}</span>
            </h5>
            <h5 class="main_info col-md-4 mb-5">
              <span class="label d-block">LGA</span>
              <span class="info">{{ getLgaName(studentInfo?.LGA) }}</span>
            </h5>
            <h5 class="main_info col-md-4 mb-5">
              <span class="label d-block">Community</span>
              <span class="info">{{
                getCommunityName(studentInfo?.Community)
              }}</span>
            </h5>
            <h5 class="main_info col-md-4 mb-5">
              <span class="label d-block">Scholarship Category</span>
              <span class="info">{{
                getScholarshipCategoryName(studentInfo?.ScholarshipCategoryId)
              }}</span>
            </h5>
            <h5 class="main_info col-md-4 mb-5">
              <span class="label d-block">Scholarship Type</span>
              <span class="info">{{
                getScholarshipTypeName(studentInfo?.ScholarshipTypeId)
              }}</span>
            </h5>
            <h5 class="main_info col-md-4 mb-5">
              <span class="label d-block">Course Of Study</span>
              <span class="info">{{
                getCourseOfStudyName(studentInfo?.CourseOfStudy)
              }}</span>
            </h5>
            <h5 class="main_info col-md-4 mb-5">
              <span class="label d-block">Phone Number</span>
              <span class="info">{{ studentInfo?.PhoneNumber }}</span>
            </h5>
            <h5 class="main_info col-md-4 mb-5">
              <span class="label d-block">Gender</span>
              <span class="info">{{ getGenderName(studentInfo?.Gender) }}</span>
            </h5>
            <h5 class="main_info col-md-4 mb-5">
              <span class="label d-block">Scholarship Award No.</span>
              <span class="info">{{ studentInfo?.ScholarshipAwardNo }}</span>
            </h5>
          </div>
        </div>
      </section>

      <h4 class="heading">Payment History</h4>
      <section class="payment_history">
        <div class="first_point row">
          <!-- <h3 class="name col-md-5" style="color:black; font-weight:bold;">
                    <span class="give__name">Account Name</span>
                    <span class="info">Iria Elvis Osas</span>
                  </h3>
                  <h3 class="account__no col-md-7" style="color:black; font-weight:bold;">
                    <span class="account">Account No.</span>
                    <span class="info">3033525825</span>
                  </h3> -->
        </div>

        <div class="grid_table">
          <div class="grid_table-head">
            <span>S/N</span>
            <span>Account Name</span>
            <span>Account No.</span>
            <span>Payment Description</span>
            <span>Bank Name</span>
            <span>Branch</span>
            <span>Amount Paid</span>
            <span>Date Paid</span>
          </div>
        </div>
        <!-- body BODY  ---------------------------------------------------------------------------BODY BODY -->
        <div
          class="grid_table-row"
          *ngFor="let payment of paymentReportInfo; index as i"
        >
          <span>{{ i + 1 }}</span>
          <span>{{ payment?.BankDetailInfo.BeneficiaryAccountName }}</span>
          <span>{{ payment?.BankDetailInfo.BeneficiaryAccountNumber }}</span>
          <span>{{ payment?.PaymentDescription }}</span>
          <span>{{ payment?.BankDetailInfo.BankName }}</span>
          <span>{{ payment?.BankDetailInfo.Branch }}</span>
          <span>{{
            payment?.AmountPaid | currency: payment?.CurrencyId:'symbol-narrow'
          }}</span>
          <span>{{ payment?.DatePaid | date }}</span>
        </div>

        <!-- TOTAL TOTAL  ---------------------------------------------------------------------------TOTAL TOTAL -->
        <div class="grid_table-total" style="padding: 0 0; margin: 0;">
          <span></span>
          <span></span>
          <span></span>
          <span>Total</span>
          <span>{{ totalAmountPaid }}</span>
          <span></span>
        </div>
      </section>
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-md-12">
      <mat-dialog-actions align="center">
        <button
          mat-raised-button
          id="modal-action-button"
          [useExistingCss]="true"
          printSectionId="print-section"
          ngxPrint
        >
          <mat-icon class="example-tab-icon">print</mat-icon> Print report
        </button>
        <!-- <button mat-raised-button  id="modal-cancel-button" (click)="closeModal()">
                  Go back
              </button> -->
      </mat-dialog-actions>
    </div>
  </div>
</div>

<div class="main" *ngIf="modalData.name === 'bankDetail'">
  <div class="row">
    <div class="col-md-10"></div>

    <div class="col-md-2">
      <span
        id="modal-cancel-button"
        (click)="closeModal()"
        style="cursor: pointer;"
      >
        <mat-icon
          class="example-tab-icon close"
          style="font-size: 28px !important;"
          >close</mat-icon
        >
      </span>
    </div>
  </div>
  <h3>Add Beneficiary Account Details</h3>
  <div class="reference_table">
    <div class="top">
      <button class="top_button" (click)="addBankDetail()">
        Add<em class="ti-plus"></em> 
      </button>

      <div class="right_part">
        <button class="top_button">Filter<em class="ti-filter"></em> </button>
        <div class="search">
          <input
            id="nav_search"
            class="input is-medium"
            placeholder="Search..."
            [formControl]="control"
            [appAutocomplete]="autocomplete"
          />
          <app-autocomplete #autocomplete="appAutocomplete">
            <ng-template appAutocompleteContent>
              <ng-container
                *ngIf="bankDetails | filter: control.value as result"
              >
                <app-option
                  (click)="clickMe(option.id)"
                  *ngFor="let option of result"
                  [value]="option.BankName"
                >
                  {{ option.BankName }}
                </app-option>
                <app-option class="no-result" *ngIf="!result.length"
                  >No result...</app-option
                >
              </ng-container>
            </ng-template>
          </app-autocomplete>
          <span class="search_icon"
            ><img src="assets/images/top_nav/Magnifiction.svg" alt=""
          /></span>
        </div>
      </div>
    </div>

    <div class="custom_table custom__table">
      <form [formGroup]="bankForm">
        <div class="thead">
          <span class="head">S/N</span>
          <span class="head">Account Name</span>
          <span class="head">Account Number</span>
          <span class="head">Bank Name</span>
          <span class="head">Sort Code</span>
          <span class="head">BVN</span>
          <span class="head">Branch</span>
          <span class="head">Remark</span>
          <span class="head">Action</span>
        </div>

        <div class="tbody" formArrayName="BankDetails">
          <div
            class="td"
            *ngFor="
              let bankDetail of bankForm.get('BankDetails')['controls'];
              index as i
            "
            [formGroupName]="i"
          >
            <span class="head">{{ i + 1 }}</span>
            <span
              ><input
                type="text"
                formControlName="BeneficiaryAccountName"
                placeholder="Enter Bank Account Name"
            /></span>
            <span
              ><input
                type="text"
                formControlName="BeneficiaryAccountNumber"
                placeholder="Enter Bank Account Number"
            /></span>
            <span>
              <!-- <mat-form-field class="bank-width-field" >
                      <mat-select placeholder="Select Bank" formControlName="BankName" >
                      <mat-option *ngFor="let bank of banks" [value]="bank.id">{{bank.BankName}}</mat-option>
                      </mat-select>
                      </mat-form-field> -->

              <select placeholder="Select Bank" formControlName="BankName">
                <option value="">Select Bank</option>
                <option *ngFor="let bank of banks" [value]="bank.id">{{
                  bank.BankName
                }}</option>
              </select>
            </span>
            <span
              ><input
                type="text"
                formControlName="SortCode"
                placeholder="Enter Sort Code"
            /></span>

            <span
              ><input
                type="text"
                formControlName="BVN"
                placeholder="Enter BVN Code"
            /></span>
            <span
              ><input
                type="text"
                formControlName="Branch"
                placeholder="Enter Branch"
            /></span>
            <span
              ><input
                type="text"
                formControlName="Remark"
                placeholder="Enter Remark"
            /></span>

            <span
              ><button
                class="delete_icon trash"
                (click)="deleteBankDetail(i, bankDetail.value)"
              >
                <em class="ti-trash"> </em> </button
            ></span>
          </div>
        </div>
        <!-- <pre>{{bankForm.value | json}}</pre> -->
        <div class="submit">
          <button
            class="submit_button"
            (click)="onSubmitBankDetail(bankForm.value)"
          >
            Submit
          </button>
          <!-- <button mat-raised-button class="ml-5"  id="modal-cancel-button" (click)="closeModal()">
                    Go back
                </button> -->
        </div>
      </form>
    </div>
  </div>
</div>
